export default __webpack_public_path__ + "static/media/ADDY.2eb755ba.png";